import * as React from 'react'
import LinearProgress, { LinearProgressProps } from '@mui/material/LinearProgress'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'

type IExtras = {
    value: number; 
    text?: string; 
    disablePercentage?: boolean
}

export default function LinearProgressWithLabel(
  props: LinearProgressProps & IExtras
) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'nowrap' }}>
      <Box sx={{ width: '100%', mr: 1 }}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      {!props.disablePercentage && (
        <Box>
          <Typography
            variant="body2"
            sx={{ color: 'RobotoRegular', textAlign: 'center', fontSize: 12 }}
          >{`${Math.round(props.value)}% ${props.text ?? ''}`}</Typography>
        </Box>
      )}
    </Box>
  )
}

export function TestLinearWithValueLabel() {
  const [progress, setProgress] = React.useState(10)

  React.useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) => (prevProgress >= 100 ? 10 : prevProgress + 10))
    }, 800)
    return () => {
      clearInterval(timer)
    }
  }, [])

  return (
    <Box sx={{ width: '100%' }}>
      <LinearProgressWithLabel value={progress} />
    </Box>
  )
}
